import {
  api_react_v1_confirm_action_via_email_code_path,
  api_react_v1_init_confirm_action_via_email_code_path,
} from '@routes';
import { SuccessResponse } from '@utils/interfaces';

import request from './request';

export interface InitConfirmActionViaEmailCodeParams {
  actionText: string;
}

export interface ConfirmActionViaEmailCodeParams {
  actionText: string;
  challengeCode: string;
}

export async function initConfirmActionViaEmailCode(
  params: InitConfirmActionViaEmailCodeParams
): Promise<SuccessResponse> {
  const resp = await request(
    'post',
    api_react_v1_init_confirm_action_via_email_code_path({
      action_text: params.actionText,
    })
  );
  return resp;
}

export async function confirmActionViaEmailCode(
  params: ConfirmActionViaEmailCodeParams
): Promise<SuccessResponse> {
  const resp = await request(
    'post',
    api_react_v1_confirm_action_via_email_code_path({
      action_text: params.actionText,
      challenge_code: params.challengeCode,
    })
  );
  return resp;
}
